import React from 'react';
import './styles.scss';

/**
 * Blog Link Component
 *
 * Links to external blog at https://blog.jrvisuals.com/
 * Provides information about blog content and encourages exploration.
 */

const BLOG_URL = 'https://blog.jrvisuals.com/';

export const BlogLink = () => {
  return (
      <section id="resources" className="section">
      <div className="container">
        <h2>Resources & Insights</h2>
        <div className="blog-link-content">
            <p>
            My blog offers <strong>personal reflections</strong>, <strong>dharma‑inspired teachings</strong>, and thoughtful explorations of the contemplative path — all written to support <strong>steadiness</strong>, <strong>insight</strong>, and a more grounded relationship with your own mind.
          </p>
          <p>
            A space for reflections on <strong>mindfulness</strong>, <strong>contemplative practice</strong>, and the texture of everyday experience. I write about practice, philosophy, and the ways <strong>ancient contemplative traditions</strong> meet the realities of modern life. You'll also find <strong>poetry</strong> and creative expressions that explore the inner landscape with clarity and warmth.
          </p>

          <div className="blog-link-button-container">
            <a
              href={BLOG_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-link-button"
            >
              Visit the Blog
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
